import Promise from 'bluebird';
import { post } from '../../lib/http-request';

import {
  validateStreet,
  validateAptSuite,
  validateCity,
  validateState,
  validateZip
} from '../../components/address/validations';
import dayJs from 'dayjs';

export const SUBMIT_MANAGEMENT_INFO = 'SUBMIT_MANAGEMENT_INFO';
export const SUBMIT_MANAGEMENT_INFO_PROCESSING = 'SUBMIT_MANAGEMENT_INFO_PROCESSING';
export const SUBMIT_MANAGEMENT_INFO_COMPLETE = 'SUBMIT_MANAGEMENT_INFO_COMPLETE';
const PROCESSING_SUBMIT = 'PROCESSING_SUBMIT';
const SUBMIT_COMPLETED = 'SUBMIT_COMPLETED';

export const UPDATE_CONTROLLER_FIELD = 'CONTROLLER_UPDATE_FIELD';
export const UPDATE_MANAGEMENT_FIELD = 'UPDATE_MANAGEMENT_FIELD';

export const updateControllerField = (field, value, errs) => {
  const errors = { ...errs };

  errors[field] = !/aptsuite/.exec(field) && !value && `${field} is required.`;

  return (dispatch) => {
    dispatch({
      type: UPDATE_CONTROLLER_FIELD,
      field,
      value,
      errors
    });
  };
};

export const updateManagementField = (field, value) => {
  const fieldDisplay = {
    verifierFirstname: 'First name',
    verifierLastname: 'Last name',
    verifierTitle: 'Title'
  };

  const messageField = fieldDisplay[field];

  const errMsg = !value && `${messageField} is required.`;

  return {
    type: UPDATE_MANAGEMENT_FIELD,
    field,
    value,
    errMsg
  };
};

const submitData = (url, managementData, owners) => {
  return post(url, {
    managementData,
    owners,
    variation: 'ALT'
  });
};

export const updateManagementInfo = (managementData, owners, submitFn = submitData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const {
        verifierFirstname,
        verifierLastname,
        verifierTitle,
        isVerified
      } = managementData;

      const ownerController = owners.find(({ type }) => type === 'OWNER_AND_CONTROLLER');

      const errors = {};
      errors.verifierFirstname = !verifierFirstname && 'First name is required.';
      errors.verifierLastname = !verifierLastname && 'Last name is required.';
      errors.verifierTitle = !verifierTitle && 'Title is required.';
      errors.isVerified = !isVerified;

      const controller = { ...managementData.controller};
      controller.errors = {};
      if (!ownerController) {
        controller.errors.firstName = !controller.firstName && 'First name is required.';
        controller.errors.lastName = !controller.lastName && 'Last name is required.';
        controller.errors.dob = (!controller.dob || !dayJs(controller.dob, 'MM/DD/YYYY').isValid()) && 'Date of birth is required.';
        controller.errors.ssn = (!controller.ssn || controller.ssn.replace('-', '').length !== 9) && 'SSN is required.';
        controller.errors.street = validateStreet(controller.address.street);
        controller.errors.aptsuite = validateAptSuite(controller.address.aptsuite);
        controller.errors.city = validateCity(controller.address.city);
        controller.errors.state = validateState(controller.address.state);
        controller.errors.zip = validateZip(controller.address.zip);
      }

      const totalErrors = { ...errors, ...controller.errors };

      const hasError = Object.keys(totalErrors)
        .reduce((acc, key) => !!totalErrors[key] || acc, false);


      if (hasError) {
        dispatch({ type: SUBMIT_MANAGEMENT_INFO, hasError, controller, errors });
        return reject({ hasError });
      }

      dispatch({
        type: PROCESSING_SUBMIT
      });

      submitFn('/patientsolutions/enroll/ownership/significant-owner', managementData, owners)
        .then((payload) => {
          dispatch({
            type: SUBMIT_MANAGEMENT_INFO_COMPLETE,
            payload
          });
          resolve();
        })
        .catch(reject)
        .finally(() => {
          dispatch({
            type: SUBMIT_COMPLETED
          });
        });
    });
  };
};

